import styled from 'styled-components'
import { Icon } from '../icon/icon'
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core'
import { irem } from '../../utils'

export const ProductCardTable = styled(Table)`
  margin: 0;
`

export const ProductCardTableBody = styled(TableBody)`
  margin: 0;
`

export const ProductCardTableRow = styled(TableRow)`
  ${props => props.theme.breakpoints.up('sm')} {
    height: ${props => props.theme.typography.pxToRem(100)};
  }

  > th,
  td {
    font-size: ${irem(15)};
    line-height: ${irem(24)};
    color: ${props => props.theme.palette.text.secondary};
    padding: ${irem(18)} ${irem(5)};

    ${props => props.theme.breakpoints.up('sm')} {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  td {
    background: ${props => props.theme.custom.colors.orange};
  }
`

export const ProductCardTableText = styled.p`
  margin: 0 auto;
  color: ${props => props.theme.palette.text.secondary};
  font-size: ${props => props.theme.typography.pxToRem(15)};
  text-align: center;
`


export const ProductTableValueCell = styled(TableCell)`
  text-align: center;
  background-color: ${props => props.theme.palette.background.default};
  font-weight: 500;
  max-width: ${irem(160)};
  white-space: normal;
    
  && {
    padding-left: ${irem(20)};
    padding-right: ${irem(20)};
  }
`
export const ProductTableKeyCell = styled(TableCell)`
  padding-left: ${props => props.theme.typography.pxToRem(4)};
  background-color: white;
`

export const ProductCardTableIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(18)};
  color: #d83b00;
`
